var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "login-container" },
    [
      _c(
        "el-form",
        {
          ref: "loginForm",
          staticClass: "login-form",
          attrs: {
            model: _vm.loginForm,
            rules: _vm.loginRules,
            "auto-complete": "on",
            "label-position": "left",
          },
        },
        [
          _c("div", { staticClass: "title-container" }, [
            _c("h3", { staticClass: "title" }, [_vm._v("商城管理系统登录")]),
          ]),
          _c(
            "el-form-item",
            { attrs: { prop: "username" } },
            [
              _c(
                "span",
                { staticClass: "svg-container" },
                [_c("svg-icon", { attrs: { "icon-class": "user" } })],
                1
              ),
              _c("el-input", {
                attrs: {
                  placeholder: "请输入登录账号",
                  tabindex: "1",
                  "auto-complete": "on",
                  clearable: "",
                },
                model: {
                  value: _vm.loginForm.username,
                  callback: function ($$v) {
                    _vm.$set(_vm.loginForm, "username", $$v)
                  },
                  expression: "loginForm.username",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { prop: "password" } },
            [
              _c(
                "span",
                { staticClass: "svg-container" },
                [_c("svg-icon", { attrs: { "icon-class": "password" } })],
                1
              ),
              _c("el-input", {
                key: _vm.passwordType,
                ref: "password",
                attrs: {
                  type: _vm.passwordType,
                  placeholder: "请输入登录密码",
                  tabindex: "2",
                  "auto-complete": "on",
                },
                model: {
                  value: _vm.loginForm.password,
                  callback: function ($$v) {
                    _vm.$set(_vm.loginForm, "password", $$v)
                  },
                  expression: "loginForm.password",
                },
              }),
              _c(
                "span",
                {
                  staticClass: "svg-container show-pwd",
                  on: { click: _vm.showPwd },
                },
                [
                  _c("svg-icon", {
                    attrs: {
                      "icon-class":
                        _vm.passwordType === "password" ? "eye" : "eye-open",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { prop: "captcha" } },
            [
              _c(
                "span",
                { staticClass: "svg-container" },
                [_c("svg-icon", { attrs: { "icon-class": "form" } })],
                1
              ),
              _c("el-input", {
                attrs: { placeholder: "请输入图形验证码", tabindex: "3" },
                nativeOn: {
                  keyup: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    )
                      return null
                    return _vm.handleLogin.apply(null, arguments)
                  },
                },
                model: {
                  value: _vm.loginForm.captcha,
                  callback: function ($$v) {
                    _vm.$set(_vm.loginForm, "captcha", $$v)
                  },
                  expression: "loginForm.captcha",
                },
              }),
              _c("el-image", {
                staticClass: "captcha-image",
                attrs: { src: _vm.captchaImage, lazy: true },
                nativeOn: {
                  click: function ($event) {
                    return _vm.handleCaptcha.apply(null, arguments)
                  },
                },
              }),
            ],
            1
          ),
          _c(
            "el-button",
            {
              staticStyle: { width: "100%" },
              attrs: {
                loading: _vm.loading,
                disabled: _vm.loading,
                type: "primary",
                size: "medium",
              },
              nativeOn: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.handleLogin.apply(null, arguments)
                },
              },
            },
            [_vm._v("登录")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }